'use client'

import { ReactNode } from 'react'
import { ThemeProvider } from '@/styles/theme.provider'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { config } from '@/config'
import AppNotification, { NotificationProvider } from '@/components/ui/Notification'
import { AuthProvider } from '@/components/auth/AuthProvider'
import { AnalyticsProvider } from '@/components/analytics/AnalyticsProvider'
import { useServiceWorker } from '@/hooks/useServiceWorker'

interface Props {
  children: ReactNode
  initialAuthState?: {
    isAuthorized: boolean
    registrantId: number | null
  }
}

export function AppProviders({ children, initialAuthState }: Props) {
  useServiceWorker()

  return (
    <AuthProvider
      initialIsAuthorized={initialAuthState?.isAuthorized}
      initialRegistrantId={initialAuthState?.registrantId ?? null}
    >
      <AnalyticsProvider>
        <GTMProvider state={{ id: config.gtmId }}>
          <ThemeProvider>
            <NotificationProvider>
              <AppNotification />
              {children}
            </NotificationProvider>
          </ThemeProvider>
        </GTMProvider>
      </AnalyticsProvider>
    </AuthProvider>
  )
}
